"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Justificativas = void 0;
var bson_1 = require("bson");
var Justificativas = /** @class */ (function () {
    function Justificativas(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.justificativa, justificativa = _c === void 0 ? '' : _c;
        this._id = _id;
        this.justificativa = justificativa;
    }
    return Justificativas;
}());
exports.Justificativas = Justificativas;
//# sourceMappingURL=Justificativas.js.map